import { CSSProperties } from "react"
import { C, radius } from "@/theme/newDesignTokens"

const page: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    padding: 20,
    boxSizing: "border-box",
    minWidth: 0,
    backgroundColor: C.white,
}

export const fullPage: CSSProperties = { ...page, height: "100vh", overflow: "auto" }
export const innerPage: CSSProperties = { ...page, flex: 1, minHeight: 0, overflow: "auto" }
export const heading: CSSProperties = { margin: 0, fontSize: 20, color: C.navyDark }
export const hint: CSSProperties = { margin: 0, color: C.navyDark, lineHeight: 1.5 }
export const actions: CSSProperties = {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 12,
    flexShrink: 0,
}
export const link: CSSProperties = { color: C.navy, padding: "8px 0" }
export const button: CSSProperties = {
    padding: "8px 16px",
    border: "none",
    borderRadius: radius.md,
    backgroundColor: C.navy,
    color: C.white,
    cursor: "pointer",
    fontSize: 14,
}
export const iframe: CSSProperties = { width: "100%", flex: "1 1 360px", minHeight: 240, border: "none" }
